import { EMPTY_LIST } from '../../../../../constants/common'

export function toCurrencyOptions(currencies) {
  return (currencies || EMPTY_LIST).map(({ code }) => ({
    label: code,
    value: code,
  }))
}
